import type {
  ContentOptimizationChannel,
  ContentOptimizationComponentName,
  PushComponentName,
  SmsComponentName,
} from "./types";
import { emailComponentNames, pushComponentNames, smsComponentNames } from "./types";

export interface ChannelComponentConfig {
  names: readonly ContentOptimizationComponentName[];
}

export interface ChannelComponentConfigOptions {
  pushImageVariantsEnabled?: boolean;
  rcsImageEligible?: boolean;
}

export const channelComponentConfig: Record<ContentOptimizationChannel, ChannelComponentConfig> = {
  email: { names: emailComponentNames },
  push: { names: pushComponentNames },
  sms: { names: smsComponentNames },
};

/** The maximum number of components in the composer for each channel. */
export const maxCoComponents = 4;

/**
 * Push Add-menu / allowlist names, with Image included only when Push image variants are enabled.
 */
const getPushComponentNames = ({
  pushImageVariantsEnabled,
}: {
  pushImageVariantsEnabled: boolean;
}): readonly PushComponentName[] => {
  if (pushImageVariantsEnabled) {
    return pushComponentNames;
  }
  return pushComponentNames.filter((name) => name !== "Image");
};

const getSmsComponentNames = ({ rcsImageEligible }: { rcsImageEligible: boolean }): readonly SmsComponentName[] => {
  if (rcsImageEligible) {
    return smsComponentNames;
  }
  return smsComponentNames.filter((name) => name !== "Image");
};

/**
 * Channel allowlist config with Image filtered by the channel-specific image-variants flippers.
 */
export const getChannelComponentConfig = (
  channel: ContentOptimizationChannel,
  { pushImageVariantsEnabled = false, rcsImageEligible = false }: ChannelComponentConfigOptions = {}
): ChannelComponentConfig => {
  const base = channelComponentConfig[channel];
  if (channel === "email") {
    return base;
  }
  if (channel === "push") {
    return {
      ...base,
      names: getPushComponentNames({ pushImageVariantsEnabled }),
    };
  }
  if (channel === "sms") {
    return {
      ...base,
      names: getSmsComponentNames({ rcsImageEligible }),
    };
  }
  return base;
};
